<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <date-picker v-model="search.date"
                             range
                             placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                             :format="changeFormat"
                             :lang="lang" confirm>
                </date-picker>
                &nbsp;
                <multiselect
                    v-model="search.sale"
                    class="form-control border-0"
                    :options="optionSeller"
                    label="name"
                    placeholder="ค้นหาเซลล์"
                    :show-labels="false"
                    :customLabel="customSaleNameWithCode"
                    track-by="id">
                </multiselect>
                &nbsp;
                <button class="btn btn-info my-2 my-sm-0"
                        @click="onPrint"
                        type="button">
                    PDF
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">เซลล์</th>
                    <th scope="col">รายละเอียดแบ่งโควต้า</th>
                    <th scope="col">รายละเอียดการจองโควต้า</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in list">
                    <td>{{ (x.sale_id + '-' + x.name) }}</td>
                    <td>
                        <a style="text-decoration: underline" @click="goSplitQuota(x.id)">
                            ดูข้อมูล
                        </a>
                    </td>
                    <td>
                        <a style="text-decoration: underline" @click="goDetailQuota(x.id)">
                            ดูข้อมูล
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../Pagination";
import Multiselect from "vue-multiselect";

import {canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import {domain} from "@/util/Constants";
import moment from "moment/moment";
import DatePicker from "vue2-datepicker";

export default {
    name: "quota-config",
    components: {
        Loading,
        VuePagination,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: '',
            status: '',
            search_text: '',
            list: [],
            optionEmployee: [],
            search: {
                date: [],
                sale: ''
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null;
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    created() {
        this.getList();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            optionSeller: state => {
                return state.Seller.data
            },
        })
    },
    methods: {
        customLabel(option) {
            return `${option.username} - ${option.name}`
        },
        customSaleNameWithCode(option) {
            return `${option.sale_id} - ${option.name}`
        },
        goSplitQuota(id) {
            this.$router.push({
                name: 'quota-sale',
                params: {id: id}
            })
        },
        goDetailQuota(id) {
            this.$router.push({
                name: 'quota-history',
                params: {id: id}
            })
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getList() {
            this.$store.dispatch('Seller/get').then(res => {
                this.list = res
            });
        },
        onPrint() {
            let start_date = '';
            let end_date = '';
            if (this.search.date.length > 0) {
                start_date = moment(this.search.date[0]).format('YYYY-MM-DD');
                end_date = moment(this.search.date[1]).format('YYYY-MM-DD');
            }
            let data = {
                date_start: start_date,
                date_end: end_date,
                sale_id: this.search.sale ? this.search.sale.id : ''
            }
            window.open(`${domain}/quota_pdf?sale_id=${data.sale_id}&date_start=${data.date_start}&date_end=${data.date_end}`);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
